module.exports = __webpack_public_path__ + "img/about.70a2c4ed.jpg";